export const mockData = {
  brandName: 'TapCard Pro',

  hero: {
    headline: 'Share Your Contact with Just a Tap',
    subheadline: 'Premium NFC business cards with UV printing. Professional, eco-friendly, and always up-to-date. Never run out of business cards again.'
  },

  features: [
  {
    icon: 'zap',
    title: 'Instant NFC Tap',
    description: 'Share your contact instantly with a simple tap. Works with all modern smartphones - no app required.',
    color: 'from-blue-600 to-blue-700'
  },
  {
    icon: 'leaf',
    title: 'Eco-Friendly',
    description: 'One card replaces thousands of paper cards. Reduce waste and save trees with digital sharing.',
    color: 'from-emerald-600 to-emerald-700'
  },
  {
    icon: 'smartphone',
    title: 'UV Printed Quality',
    description: 'Premium plastic cards with high-quality UV printing. Durable, professional, and waterproof.',
    color: 'from-slate-600 to-slate-700'
  },
  {
    icon: 'shield',
    title: "Update easily",
    description: "We can change your contact info anytime. Your card always shares the latest information automatically.",
    color: 'from-blue-600 to-slate-700'
  }],


  howItWorks: [
  {
    step: '1',
    title: 'Order Your Card',
    description: 'Choose your design and customize your card with your branding and information.'
  },
  {
    step: '2',
    title: "Send Your Info",
    description: "We create your digital profile with contact info, social links, and even YouTube video."
  },
  {
    step: '3',
    title: 'Start Networking',
    description: 'Simply tap your card on any smartphone to instantly share your information.'
  }],


  products: [
  {
    id: 'nfc',
    name: 'NFC Business Card',
    description: 'Premium plastic card with NFC technology and UV printing',
    price: "Order Now - 1100 PHP per 1 year",
    image: 'https://customer-assets-7cd3h4nn.emergentagent.net/job_tap-card-hub/artifacts/rvubue88_MC%20Card.jpg',
    features: [
    'NFC chip embedded',
    'One-side UV printing',
    'Waterproof & durable',
    'Digital profile included',
    'Affordable updates']

  },
  {
    id: 'id',
    name: 'Printed ID Card',
    description: 'Professional ID cards with high-quality printing',
    price: 'Request a price estimate',
    image: 'https://customer-assets.emergentagent.com/job_tap-card-hub/artifacts/156bbcg8_1.png',
    features: [
    'High-resolution printing',
    'Plastic PVC card',
    'Photo ID ready',
    'Custom design options',
    'Quick turnaround']

  }],


  stats: {
    customers: '10,000+',
    uptime: '99.9%',
    rating: '4.9'
  }
};